import { isAxiosError } from 'axios'
import { showErrorToast } from 'shared/utils/toast.ts'
import { usePromise } from 'shared/hooks/usePromise'
import { postDonation } from './utils'
import { useStreamerConfigContext } from '@/contexts/StreamerConfigContext/StreamerConfigContext'
import { FormValues } from '@/pages/Donation/types'
import { processErrorResponse } from '@/shared/utils/processErrorResponse.tsx'

type Props = {
  isDisabled: boolean
}

/**
 * Todo: refactor to process specific error codes when backend will pass them to frontend
 */
const checkRequestError = (error: unknown) => isAxiosError(error) && error?.status === 400

export const usePostDonation = ({ isDisabled }: Props) => {
  const { username } = useStreamerConfigContext()

  const {
    send: postDonate,
    isLoading,
    error,
    reset,
  } = usePromise(
    async (values: FormValues) => {
      if (isDisabled) {
        return
      }

      return postDonation({
        values,
        username,
        origin: window.location.href,
      })
    },
    {
      onError: error => {
        if (!checkRequestError(error)) {
          showErrorToast(processErrorResponse(error))
        }
      },
      onSuccess: result => {
        const redirectURI = result?.data.redirect_uri

        if (redirectURI) {
          window.location.href = redirectURI
        }
      },
    }
  )

  const isRequestError = checkRequestError(error)

  return {
    postDonate,
    isLoading,
    isRequestError,
    reset,
  }
}
